// administratorConfig.ts
import { FieldTypeEnum, FormField } from '../../Form/DynamicForm'
import { TableColumn, enumTypeColumn } from '../../Table'

export const columnsCorporate: TableColumn[] = [
  {
    title: 'Foto',
    dataIndex: 'photo',
    key: 'photo',
    type: enumTypeColumn.photo
  },
  {
    title: 'Nombre',
    dataIndex: 'name',
    key: 'name',
    type: enumTypeColumn.string
  },
  {
    title: 'Apellido',
    dataIndex: 'lastName',
    key: 'lastName',
    type: enumTypeColumn.string
  },
  {
    title: 'User',
    dataIndex: 'userName',
    key: 'userName',
    type: enumTypeColumn.string
  },
  {
    title: 'Número',
    dataIndex: 'phoneNumber',
    key: 'phoneNumber',
    type: enumTypeColumn.string
  },
  {
    title: 'Creado en',
    dataIndex: 'createdAt',
    key: 'createdAt',
    type: enumTypeColumn.date
  }
]

export const CorporateFormConfig: FormField[] = [
  { type: FieldTypeEnum.image, label: 'Foto', name: 'photo' },
  { type: FieldTypeEnum.text, label: 'Nombre', name: 'name' },
  { type: FieldTypeEnum.text, label: 'Apellido', name: 'lastName' },
  { type: FieldTypeEnum.text, label: 'User', name: 'userName' },
  { type: FieldTypeEnum.phone, label: 'Número', name: 'phoneNumber' },
  { type: FieldTypeEnum.text, label: 'Contraseña', name: 'password' }
]
